import { Product } from "@dashboard/types/product";
import type { ReduxState } from "@dashboard/types/reduxState";

import { RestaurantSelectedAction } from "./restaurantReducer";

type DeleteProductReducerAction = {
  type: "DELETE_PRODUCT";
  payload: string;
}; // payload is productId

export type ProductReducerAction =
  | DeleteProductReducerAction
  | RestaurantSelectedAction
  | (
      | { type: "SET_PRODUCT"; payload: Product }
      | { type: "FETCHED_PRODUCTS"; payload: Product[] }
    ); // payload is products // payload is productId, null means update errored or finished

export const productReducer: (
  state: ReduxState["product"] | undefined,
  action: ProductReducerAction
) => ReduxState["product"] = (
  state: ReduxState["product"] = {
    initialProductsLoading: true,
    products: [],
  },
  action: ProductReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_SELECTED":
      return {
        ...state,
        initialProductsLoading: true,
      };
    case "SET_PRODUCT":
      // if the product is already present, we update it
      // else we add it to the beginning.
      const productIndex = state.products.findIndex(
        (product) => product.id === action.payload.id
      );

      if (productIndex !== -1) {
        // update
        return {
          ...state,
          products: [
            ...state.products.slice(0, productIndex),
            action.payload,
            ...state.products.slice(productIndex + 1),
          ],
        };
      } else {
        // add
        return {
          ...state,
          products: [action.payload, ...state.products],
        };
      }
    case "DELETE_PRODUCT":
      // FIXME remove from dishes as well.
      // setup updated timestamp on dishes.
      return {
        ...state,
        products: state.products.filter(
          (product) => product.id !== action.payload
        ),
      };
    case "FETCHED_PRODUCTS":
      return {
        ...state,
        initialProductsLoading: false,
        products: action.payload, // ordering is done in the action
      };
    default:
      return state;
  }
};
